<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        email
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <span :class="ui.textTitle">
              <v-icon left :color="ui.btnColor">
                <!-- {{defineDocumentFromTag(this.localForm.tag).icon}} -->
              </v-icon>
              <!-- {{defineDocumentFromTag(result.char.tag).title}} -->
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              <!-- {{displayDocumentIDGTypeA(result.basic.tag, result.basic.idg)}} -->
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>title</v-icon>
                </v-avatar>
                {{result.char.title}}
              </v-chip>
            </span>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" v-if="result.basic.act === false">
              <v-icon :color="ui.btnColor">
                lock
              </v-icon>
            </v-chip>
          </v-layout>
            <v-layout row>
              <span :class="ui.textSubheading">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                    <v-icon>sell</v-icon>
                  </v-avatar>
                  {{result.char.id}}
                </v-chip>
              </span>
              <v-spacer/>
            </v-layout>
          <v-layout>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> change_history </v-icon>
              </v-avatar>
              <!-- {{this.generateDocumentLogShortText(result.char.tag, result.char.tverb)}} -->
            </v-chip>
          </v-layout>
          <v-layout class="mt-4">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> person </v-icon>
              </v-avatar>
              {{result.stats.uname}}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>schedule</v-icon>
              </v-avatar>
              {{dateTimeAgo(result.stats.dcrt)}}
            </v-chip>
          </v-layout>
          <v-layout>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> notes </v-icon>
              </v-avatar>
              {{result.rev.modmc}}
            </v-chip>
          </v-layout>
          <v-layout v-if="result.rev.modc !== result.rev.modm">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> short_text </v-icon>
              </v-avatar>
              {{result.rev.modcc}}
            </v-chip>
          </v-layout>
          <v-layout class="mt-1">
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>create</v-icon>
              </v-avatar>
              <DocumentStatus :data="{
                model: 'STD',
                rev: this.displayDocumentRevTypeA(result.rev),
                sec: result.rev.sec,
                stat: result.rev.stat,
                type: result.rev.type}
                "/>
            </v-chip>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            close
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import textFunctions from "@/data/functions/mixins/textFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import updateFirebase from "@/data/cloud/firebase/mixins/updateFirebase.js";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";

export default {
  mixins: [
    apptheme,
    dateFunctions,
    numberFunctions,
    storeFunctions,
    routerFunctions,
    describeDocument,
    displayFunctions,
    textFunctions,
    dataSources,
    updateFirebase,
    revFunctions
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      localForm: {
        tag: "U1",
        icon: "Undefined"
      }
    };
  },
  beforeMount() {
    this.localForm.tag = this.result.char.tag;
    this.localForm.title = "undefined";
  },
  components: {
    DocumentStatus
  },
  computed: {
    ...mapGetters(["getDataSource", "getSearchResults"]),
    result() {
      return this.data.item;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
